import React from 'react';
import './OrderTile.css';

export default function OrderTile({ order, onClick }) {
  // Extract fields with fallback
  const images = Array.isArray(order.images) ? order.images : (order.imageUrls || []);
  const cakeWritings = order.cakeWritings || order.title || order.description || '';
  const createdByPhoto = order.createdByPhoto || '';
  const createdByName = order.createdByName || order.bakerName || '';
  const cakePrice = order.cakePrice || order.price || '';
  const pickTime = order.pickTime || order.time || '';
  const deliveryDate = order.pickDate || order.deliveryDate || '';
  const status = order.status && order.status.length > 0 ? order.status : 'Sent to Bakery';

  // Status color logic
  function getStatusColor(status) {
    if (status.toLowerCase().includes('completed')) return '#26b26b';
    if (status.toLowerCase().includes('sent')) return '#e85d9e';
    return '#e85d9e';
  }

  // Price formatting
  function formatPrice(price) {
    if (!price) return '';
    return 'UGX. ' + Number(price).toLocaleString();
  }

  // Date formatting
  function formatDate(date) {
    if (!date) return '';
    if (typeof date === 'object' && date._seconds) {
      date = new Date(date._seconds * 1000);
    } else if (typeof date === 'string' || typeof date === 'number') {
      date = new Date(date);
    }
    if (isNaN(date.getTime())) return '';
    return date.toISOString().slice(0, 10);
  }

  return (
    <div className="order-tile-card" onClick={onClick} tabIndex={0} role="button">
      <div className="order-tile-leading">
        {images.length > 0 ? (
          <img src={images[0]} alt="Cake" className="order-tile-img" />
        ) : (
          <div className="order-tile-img order-tile-img-fallback">
            <span role="img" aria-label="cake" style={{fontSize: 32, color: '#e85d9e'}}>🎂</span>
          </div>
        )}
      </div>
      <div className="order-tile-main">
        <div className="order-tile-title">
          {cakeWritings.length > 22 ? cakeWritings.substring(0, 22) + '...' : cakeWritings}
        </div>
        {deliveryDate && (
          <div className="order-tile-delivery">Delivery: {formatDate(deliveryDate)}</div>
        )}
        <div className="order-tile-row">
          <div className="order-tile-price">{formatPrice(cakePrice)}</div>
          {pickTime && <div className="order-tile-time"><span role="img" aria-label="clock">⏰</span> {pickTime}</div>}
        </div>
        {createdByName && (
          <div className="order-tile-by">By {createdByName}</div>
        )}
        <div className="order-tile-row">
          <span className="order-tile-chip" style={{background: getStatusColor(status)}}>{status}</span>
        </div>
      </div>
      <div className="order-tile-trailing">
        {createdByPhoto ? (
          <img src={createdByPhoto} alt="User" className="order-tile-avatar" />
        ) : (
          <div className="order-tile-avatar order-tile-avatar-fallback">
            <span role="img" aria-label="user" style={{color: '#e85d9e'}}>👤</span>
          </div>
        )}
      </div>
    </div>
  );
}
